import _objectSpread from "/Users/oleksandrlevinskyi/code/meaningful-careers/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import { makeDsn, dsnToString, urlEncode } from '@sentry/utils';
var SENTRY_API_VERSION = '7';

/** Returns the prefix to construct Sentry ingestion API endpoints. */
function getBaseApiEndpoint(dsn) {
  var protocol = dsn.protocol ? "".concat(dsn.protocol, ":") : '';
  var port = dsn.port ? ":".concat(dsn.port) : '';
  return "".concat(protocol, "//").concat(dsn.host).concat(port).concat(dsn.path ? "/".concat(dsn.path) : '', "/api/");
}

/** Returns the ingest API endpoint for target. */
function _getIngestEndpoint(dsn) {
  return "".concat(getBaseApiEndpoint(dsn)).concat(dsn.projectId, "/envelope/");
}

/** Returns a URL-encoded string with auth config suitable for a query string. */
function _encodedAuth(dsn, sdkInfo) {
  return urlEncode(_objectSpread({
    // We send only the minimum set of required information. See
    // https://github.com/getsentry/sentry-javascript/issues/2572.
    sentry_key: dsn.publicKey,
    sentry_version: SENTRY_API_VERSION
  }, sdkInfo && {
    sentry_client: "".concat(sdkInfo.name, "/").concat(sdkInfo.version)
  }));
}

/**
 * Returns the envelope endpoint URL with auth in the query string.
 *
 * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
 */
function getEnvelopeEndpointWithUrlEncodedAuth(dsn, tunnel, sdkInfo) {
  return tunnel ? tunnel : "".concat(_getIngestEndpoint(dsn), "?").concat(_encodedAuth(dsn, sdkInfo));
}

/** Returns the url to the report dialog endpoint. */
function getReportDialogEndpoint(dsnLike, dialogOptions) {
  var dsn = makeDsn(dsnLike);
  if (!dsn) {
    return '';
  }
  var endpoint = "".concat(getBaseApiEndpoint(dsn), "embed/error-page/");
  var encodedOptions = "dsn=".concat(dsnToString(dsn));
  for (var key in dialogOptions) {
    if (key === 'dsn') {
      continue;
    }
    if (key === 'onClose') {
      continue;
    }
    if (key === 'user') {
      var user = dialogOptions.user;
      if (!user) {
        continue;
      }
      if (user.name) {
        encodedOptions += "&name=".concat(encodeURIComponent(user.name));
      }
      if (user.email) {
        encodedOptions += "&email=".concat(encodeURIComponent(user.email));
      }
    } else {
      encodedOptions += "&".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(dialogOptions[key]));
    }
  }
  return "".concat(endpoint, "?").concat(encodedOptions);
}
export { getEnvelopeEndpointWithUrlEncodedAuth, getReportDialogEndpoint };